var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 16,
    fill: "#FFA400"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1789_4426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4381 20.6336L31.0561 20.0156L29.2022 18.1617L25.8061 14.7656L23.9522 12.9117L23.3342 13.5297L22.0983 14.7656L11.2045 25.6594C10.6358 26.2281 10.2201 26.9336 9.99045 27.7047L8.05451 34.2891C7.91779 34.7484 8.04357 35.2461 8.3881 35.5851C8.73264 35.9242 9.22482 36.05 9.6842 35.9187L16.2631 33.9828C17.0342 33.7531 17.7397 33.3375 18.3084 32.7687L29.2022 21.875L30.4381 20.6336ZM16.7498 29.843L16.2522 31.0844C16.0334 31.2539 15.7873 31.3797 15.5248 31.4617L11.2483 32.7195L12.5061 28.4484C12.5826 28.1805 12.7139 27.9344 12.8834 27.7211L14.1248 27.2234V28.9734C14.1248 29.4547 14.5186 29.8484 14.9998 29.8484H16.7498V29.843ZM27.835 9.02344L27.0475 9.81641L25.8115 11.0523L25.1881 11.6703L27.042 13.5242L30.4381 16.9203L32.292 18.7742L32.91 18.1562L34.1459 16.9203L34.9389 16.1273C36.3061 14.7602 36.3061 12.5453 34.9389 11.1781L32.7897 9.02344C31.4225 7.65625 29.2076 7.65625 27.8405 9.02344H27.835ZM25.2428 18.2109L17.3678 26.0859C17.0287 26.425 16.4709 26.425 16.1319 26.0859C15.7928 25.7469 15.7928 25.1891 16.1319 24.85L24.0069 16.975C24.3459 16.6359 24.9037 16.6359 25.2428 16.975C25.5819 17.3141 25.5819 17.8719 25.2428 18.2109Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1789_4426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnEditar);
export default __webpack_public_path__ + "static/media/btn-Editar.c5ca05befc3cea2810daee0d222ccc04.svg";
export { ForwardRef as ReactComponent };